module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projectAdd"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("HTML5项目")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("添加项目")])], 1), _vm._v(" "), _c('el-form', {
    ref: "addProjectForm",
    staticClass: "addProjectForm",
    attrs: {
      "model": _vm.addProjectForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "projectName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写项目标题"
    },
    model: {
      value: (_vm.addProjectForm.projectName),
      callback: function($$v) {
        _vm.addProjectForm.projectName = $$v
      },
      expression: "addProjectForm.projectName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属大区",
      "prop": "company"
    }
  }, [_c('el-select', {
    staticClass: "form-select",
    attrs: {
      "placeholder": "请选择大区"
    },
    model: {
      value: (_vm.addProjectForm.company),
      callback: function($$v) {
        _vm.addProjectForm.company = $$v
      },
      expression: "addProjectForm.company"
    }
  }, _vm._l((_vm.companyOptions), function(companyItem) {
    return _c('el-option', {
      key: companyItem,
      attrs: {
        "label": companyItem,
        "value": companyItem
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接",
      "prop": "link"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写项目正式链接"
    },
    model: {
      value: (_vm.addProjectForm.link),
      callback: function($$v) {
        _vm.addProjectForm.link = $$v
      },
      expression: "addProjectForm.link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "概述",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写项目概述"
    },
    model: {
      value: (_vm.addProjectForm.content),
      callback: function($$v) {
        _vm.addProjectForm.content = $$v
      },
      expression: "addProjectForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目经理",
      "prop": "createUser"
    }
  }, [_c('el-select', {
    staticClass: "form-select",
    attrs: {
      "placeholder": "请选择项目经理"
    },
    model: {
      value: (_vm.addProjectForm.createUser),
      callback: function($$v) {
        _vm.addProjectForm.createUser = $$v
      },
      expression: "addProjectForm.createUser"
    }
  }, _vm._l((_vm.userList), function(userItem) {
    return _c('el-option', {
      key: userItem.userId,
      attrs: {
        "label": userItem.userName,
        "value": userItem.userId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addProject('addProjectForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearProjectData
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c48b82a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/h5/Add.vue
// module id = 792
// module chunks = 1